import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import 'element-plus/dist/index.css'

let app = createApp(App);
app.use(ElementPlus, {
  locale: zhCn
});
app.use(router);

app.mount('#app');


